'use strict';

module.exports = [() => {
    return {
        templateUrl: '/partial/app.partials.app.rm_face',
        replace: true,
        controllerAs: 'ctrl',
        scope: {
            user: '=',
        },
    };
}];
